import React, { useMemo } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components';
import { useIsMobile } from 'Hooks';

import styles from './TenantSelectDropdown.module.scss';

export interface TenantOption {
  label: string;
  value: string | number;
}

interface TenantSelectDropdownProps {
  options: TenantOption[];
  selectedValue?: string | number;
  onChange: (value: string | number) => void;
  disabled?: boolean;
}

export const TenantSelectDropdown: React.FC<TenantSelectDropdownProps> = ({
  options = [],
  selectedValue,
  onChange,
  disabled = false
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const placeholderText = useMemo(() => {
    return t('phishingManager.selectTenant');
  }, [t]);

  return (
    <div
      className={`pm-dropdown-section ${styles.dropdownSection} ${
        isMobile ? styles.mobile : ''
      }`}
    >
      <label
        htmlFor="pm-client-select"
        className={`pm-client-label ${styles.clientLabel}`}
      >
        {t('phishingManager.tenant')}
      </label>

      <Select
        id="pm-client-select"
        placeholder={placeholderText}
        dropdownClassName="campaign-setup-filter-option-select phishing-tenant-dropdown"
        className={`${styles.tenantSelect} ${isMobile ? styles.mobile : ''}`}
        value={selectedValue}
        onChange={onChange}
        showSearch
        disabled={disabled}
        optionFilterProp="label"
        suffixIcon={<Icon type="chevronDown" />}
        options={options}
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      />
    </div>
  );
};

export default TenantSelectDropdown;